import { render, staticRenderFns } from "./Lahan.old.vue?vue&type=template&id=7d5dbd87"
import script from "./Lahan.old.vue?vue&type=script&lang=js"
export * from "./Lahan.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports